import * as React from "react";
import { FC } from "react";
import { Create, CreateProps, SimpleForm } from "react-admin";
import { TitleAircraftType } from "./Constant/Source";
import AircraftTypeCreateForm from "./Forms/AircraftTypeCreateForm";

const AircraftTypeCreate: FC<CreateProps> = props => {
  return (
    <Create {...props} title={TitleAircraftType.create}>
      <SimpleForm>
        <AircraftTypeCreateForm />
      </SimpleForm>
    </Create>
  );
};

export default AircraftTypeCreate;
